import { useState, useEffect } from 'react'

const fetchFulfilmentPassStatus = async userId => {
  const timestamp = `${Date.now()}-${Math.random()
    .toString(36)
    .substring(2, 9)}`
  const response = await fetch(`/product-api/fulfilment-pass-service/${timestamp}`, {
    headers: {
      'X-User-Id': userId
    }
  })

  if (!response.ok) {
    const error = new Error(`HTTP error! status: ${response.status}`)
    error.status = response.status
    throw error
  }

  const data = await response.json()
  return data
}

export const useFulfilmentPassStatus = ({ userId, hasUserIdLoaded, enabled = true }) => {
  const [fulfilmentPassDetails, setFulfilmentPassDetails] = useState({
    status: 'idle', // 'idle' | 'loading' | 'success' | 'error'
    hasActivePass: false,
    passThreshold: null,
    error: null
  })

  useEffect(() => {
    if (!enabled || !hasUserIdLoaded) {
      return
    }

    if (!userId) {
      setFulfilmentPassDetails({
        status: 'success',
        hasActivePass: false,
        passThreshold: null,
        error: null
      })
      return
    }

    setFulfilmentPassDetails(prev => ({ ...prev, status: 'loading' }))

    fetchFulfilmentPassStatus(userId)
      .then(data => {
        setFulfilmentPassDetails({
          status: 'success',
          hasActivePass: data?.active,
          passThreshold: data?.threshold,
          error: null
        })
      })
      .catch(error => {
        const is404 = error.status === 404

        if (!is404) {
          console.error('Error fetching fulfilment pass status: ', error)
        }

        setFulfilmentPassDetails({
          status: is404 ? 'success' : 'error',
          hasActivePass: false,
          passThreshold: null,
          error: is404 ? null : error
        })
      })
  }, [enabled, hasUserIdLoaded, userId])

  return enabled ? fulfilmentPassDetails : null
}
